import { Schema } from "rsuite";

const { StringType, ArrayType, NumberType } = Schema.Types;

export const CompanyFormSchema = Schema.Model({
  Name: StringType().maxLength(60).isRequired("Name is required"),
  DisplayName: StringType()
    .maxLength(100)
    .isRequired("DisplayName is required"),
  Email: StringType()
    .maxLength(50)
    .isEmail("Must be a valid email")
    .isRequired("Email is required"),
  Phone: StringType().maxLength(20),
  Address: StringType().maxLength(200),
  Rate: NumberType().max(1000000),
  RepresentativeName: StringType().maxLength(60),
  RepresentativePhone: StringType().maxLength(20),
  Documents: ArrayType("Please select valid files"),
  SubscriptionType: StringType().isRequired("Subscription Type is required"),
  ProviderNumber: StringType().isRequired().maxLength(30),
  InsuranceTypeId: StringType(),
});
